import React, { useState, useEffect } from 'react';
import '../style/NavigationPage.css'; // 引入样式文件
import { groupBy, getUrlWithParams } from '../utils/common';
import { filterTree } from '../utils/index.js';
import { cosUrl } from '../const/menuData.js';
import { useHistory } from "react-router-dom";
import Header from './common/Header/index.jsx';
import { Select } from 'tdesign-react';

const NavigationPage = ({ navList,onChangeAction }) => {
  const [menuList, setMenuList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const history = useHistory()
  useEffect(() => {
    handleSetMenuList(navList);
  }, [navList])

  const handleSetMenuList = (menu) => {
    if (menu.length > 0) {
      const _menu = groupBy(menu, 'row', {
        sort: 'asc'
      });
      setMenuList(_menu);
      let list = navList.map(i => i.children).flat();
      // setSearchList(list);
    } else {
      // TODO: 跳转到错误页面 or 用默认配置
      return []
    }
  }

  const handleSearch = (searchVal) => {
      if(!searchVal){
        setSearchList([]) ;
        return;
      }
      let list = navList.map(i => i.children).flat();
      let searchList = filterTree(list, (item) => {
        return item.title.includes(searchVal) || item.text?.includes(searchVal) || item.action?.includes(searchVal)
      });
      setSearchList(searchList);
  }

  return (
    <div className="navigation-container">
      <Header />
      <div className="menu_content">
        <div className="center-container">
          <div className="welcom_container">
            <div className="welcom_title">
              <img className="menuTitle__icon" src={cosUrl + '/icon/star.png'} />
              <div>欢迎来到</div>
              <div className="menuTitle__name">文字识别 OCR </div>
              <div>体验中心 </div>
            </div>
            <div className="index-search_container">
              <Select 
              style={{width: '280px'}}
                filterable
                keys={{
                  value:"action",
                  label:"title"
                }}
                suffixIcon={<span className="ocrDemo-icon_search" onClick={handleSearch}></span>}
                placeholder="输入关键词，快速找到所需功能"
                value={searchVal}
                onChange={(val) => {
                  history.push({search: `action=${val}`})
                  setSearchVal(searchVal)
                  onChangeAction(val)
                }}
                options={searchList}
                onSearch={(searchVal) => {
                  handleSearch(searchVal)
                }}
                />

            </div>

          </div>

          <div className="menu_container">
            {
              menuList.map(row => (<div className="menu_row">
                {
                  row.map(menu => (<div className="menu_detail__container">
                    <div className="menuTitle_container">
                      <img className="menuTitle__icon" src={cosUrl + menu.icon} />
                      <div className="menuTitle__text">{menu.title}</div>
                    </div>
                    {
                      menu.children.map(menuItem => (<div className="menuItem_container">
                        <div className="menuItem_text" onClick={() => {
                          history.push({search: `action=${menuItem.action}`})
                          onChangeAction(menuItem.action)

                        }}>{menuItem.title}</div>
                        {
                          menuItem.Tag?.includes('New') && <div className="tag-new"></div>
                        }
                        {
                          menuItem.Tag?.includes('Hot') && <div className="tag-hot"></div>
                        }
                      </div>))
                    }

                  </div>))
                }
              </div >))
            }
          </div>
        </div>
      </div>


    </div>
  );
};

export default NavigationPage;